import { ApplicationConfig, APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgbDateAdapter, NgbDateNativeUTCAdapter, NgbDropdownModule, NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { JwtModule } from '@auth0/angular-jwt';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ThemeService } from 'ng2-charts';

import { AppConfigService } from './shared/services/app-config.service';
import { AuthenticationInterceptor } from './shared/interceptors/authentication.interceptor';
import { HttpParamsInterceptor } from './shared/interceptors/http-params.interceptor';
import { JwtInterceptor } from './shared/interceptors/jwt.interceptor';

import { ConsolidationFilterPanelComponent } from './shared/components/consolidation-filter-panel/consolidation-filter-panel.component';
import { TrackingTrackerFilterPanelComponent } from './shared/components/tracking-tracker-filter-panel/tracking-tracker-filter-panel.component';
import { AdminDashboardDataService } from './admindashboard/services/admindashboard-data.service';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { routes } from './layout/layout.routes';
import { appRoutes } from './app.routes';
import { authRoutes } from './authentication/authentication.routes';
import { trackerRoutes } from './tracker/tracker.routes';
import { termsRoutes } from './terms/components/terms.config';
import { contactUsRoutes } from './contact/contactus.routes';
import { quoteRequestRoutes } from './quoterequest/quoterequest-routing.routes';
import { termsAndConditionRoutes } from './terms/components/view-terms-and-conditions-routes';
import { consolidationRoutes } from './consolidation/consolidation-routes';
import { admindashboardRoutes } from './admindashboard/admindashboard-routes';
import { administrationRoutes } from './administration/administration-routes';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgbAccordionModule, NgbAlertModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { chnagePasswordRoutes } from './changepassword/changepassword-routes';



export function tokenGetter(): string {
  return sessionStorage.getItem('access_token') ?? '';
}

const appInitializerFn = (appConfig: AppConfigService) => {
  return () => appConfig.loadAppConfig();
};


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter([...routes]),

    provideHttpClient(withInterceptorsFromDi()),

    // Import modules that are not standalone
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      ReactiveFormsModule,
      NgbModalModule,
      NgbDropdownModule,
      MatSnackBarModule,
      NgbModule,
      CKEditorModule,
      NgbAccordionModule,
      NgbDatepickerModule,
      JwtModule.forRoot({
        config: {
          tokenGetter,
          skipWhenExpired: true
        }
      }),
      BrowserAnimationsModule,
      NoopAnimationsModule
    ),

    // Services
    AppConfigService,
    AdminDashboardDataService,
    ThemeService,
    ConsolidationFilterPanelComponent,
    TrackingTrackerFilterPanelComponent,

    // APP INITIALIZER
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    },

    // HTTP Interceptors
    // {
    //   provide: AuthenticationInterceptor,
    //   useClass: AuthenticationInterceptor
    // },
    // {
    //   provide: HttpParamsInterceptor,
    //   useClass: HttpParamsInterceptor
    // },
    {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpParamsInterceptor,
  multi: true
},
    // {
    //   provide: JwtInterceptor,
    //   useClass: JwtInterceptor
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    // NG Bootstrap Date Adapter
    {
      provide: NgbDateAdapter,
      useClass: NgbDateNativeUTCAdapter,
    },

    // added these line for 17+ 401 unauthorized interceptor handling
    {
      provide: AuthenticationInterceptor,
      useClass: AuthenticationInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true
    } 
  ]
};
